import { css } from '@emotion/css';
import { TFunction } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MyDesign } from '../../models/MyDesign';
import { StartQrScanButton } from './StartQrScanButton';
import { UploadedDesign } from './UploadedDesign';

const pleaseDownloadMyDesignStyles = css`
  max-width: 480px;
  color: #4d3906;
  margin: 0 auto;
  padding: 0 24px;
  h2 {
    font-size: 14px;
    margin: 12px 0;
  }
  .desc {
    font-size: 14px;
    margin: 12px 0 32px;
  }
  .buttons button {
    margin: 0 0 16px;
  }
`;

interface PleaseDownloadMyDesignProps {
  myDesign: MyDesign;
  isLoading: boolean;
}

export const PleaseDownloadMyDesign: React.FC<PleaseDownloadMyDesignProps> = ({
  myDesign,
  isLoading
}) => {
  const { t } = useTranslation('my_design');
  const isPro = myDesign.designType === 'pro';
  const uploadedDesignLabel = getText(isPro, t);
  return (
    <section className={pleaseDownloadMyDesignStyles}>
      <h2>{uploadedDesignLabel}</h2>
      <UploadedDesign {...{ myDesign, isLoading }} />
      <p className="desc">{t('top_desc_03')}</p>
      <div className="buttons">
        <StartQrScanButton source="camera" />
        <StartQrScanButton source="photoLibrary" />
      </div>
    </section>
  );
};

function getText(isPro: boolean, t: TFunction) {
  let label: string;
  if (isPro) {
    label = t('top_desc_04_pro');
  } else {
    label = t('top_desc_04');
  }
  return label;
}
